export default __webpack_public_path__ + "static/media/ballon.3ebfd127.svg";